import { ComponentClass, Component as ReactComponent } from 'react'
import { hoistNonReactStatics } from 'tangle-shared'
import { captureWarning } from 'helpers/errorHelpers'
import { perfMeasure, PERF_MARKS } from 'helpers/analyticsHelpers'

const withPerformanceMetrics = function <TProps> (
  Component: ComponentClass<TProps>,
  componentName?: string
) {
  class ComponentWithPerformanceMetrics extends ReactComponent<TProps> {
    static displayName = `withPerformanceMetrics(${ Component.displayName || Component.name })`

    render () {
      return (
        <Component { ...this.props } />
      )
    }

    componentDidMount () {
      const componentMetricName = componentName || Component.displayName || Component.name
      if (!componentMetricName) {
        captureWarning('Invalid block name for metrics')
        return
      }

      perfMeasure(PERF_MARKS.blockTTI, componentMetricName)
    }
  }

  return hoistNonReactStatics(ComponentWithPerformanceMetrics, Component)
}

export default withPerformanceMetrics
